<template>
    <service-card
        :service-tips="serviceTips"
        :service="service"
        icon="mdi-credit-card-outline"
        :is-first="isFirst"
        :order="order"
        :variants-available="variantsAvailable"
        @show-info="showInfo"
        @modify-service="$emit('modify-service', $event)"
        @minimized-change="minimizedChange"
    >
        <template v-slot:checkbox>
            <slot name="checkbox" />
        </template>
        <template v-slot:icons>
            <slot name="icons" />
        </template>
        <template v-slot:orderInfo>
            <order-info-base
                :service="service"
                :service-check-in="serviceCheckIn"
                :service-check-out="serviceCheckOut"
                :service-image="mainImage"
                :is-package="isPackage"
                :tariff-name="service.serviceDetails[0].tariffName"
                :order="order"
                :order-end-date="orderEndDate"
                @cancel-service="$emit('cancel-service', $event)"
                @modify-service="$emit('modify-service', $event)"
            >
                <div class="mt-4">
                    {{ `${$t('visa.entry_type')}: ${service.serviceDetails[0].entryType}` }}
                </div>
            </order-info-base>
        </template>
        <template v-if="info" v-slot:serviceInfo>
            <service-info-dialog v-model="modal" :service="service" :info="info" :image="mainImage" />
        </template>
    </service-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import ServiceCard from '~src/components/account/orderServices/serviceCard.src'
    import OrderInfoBase from '~src/components/account/orderServices/orderInfoBase.src'
    import ServiceInfoDialog from '~/components/account/orderServices/ServiceInfoDialog.vue'
    import {ServiceBase} from '@/components/account/orderServices/ServiceBase.vue'

    @Component({
        components: {
            ServiceCard,
            OrderInfoBase,
            ServiceInfoDialog,
        },
    })
    export class VisaService extends ServiceBase {
        @Prop({required: true}) service
        @Prop({default: false}) isPackage
        @Prop() isFirst

        modal = false
        info = null

        showInfo() {
            // this.modal = true
        }

        get serviceCheckIn() {
            const time = this.service.serviceDetails[0].checkInFrom
            const date = this.$filters.dateFormat(this.service.startDateTime)
            return time ? `<span>${date}</span> <small>${this.$t('time_from')} ${time}</small>` : date
        }

        get serviceCheckOut() {
            const time = this.service.serviceDetails[0].checkOutTo
            const date = this.$filters.dateFormat(this.service.endDateTime)
            return time ? `<span>${date}</span> <small>${this.$t('time_before')} ${time}</small>` : date
        }

        get mainImage() {
            return this.info && this.info.mainImage ? this.info.mainImage.url : ''
        }
    }

    export default VisaService
</script>

<style scoped></style>
